import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// CUSTOM HOOKS
import useGetAllOrganizationsLight from "../../../customHooks/GET_requests/useGetAllOrganizationsLight";
// INTERFACES
import { OganizationLightInterface } from "../../../interfaces/Organizations.interface";
import { SelectOrganizationInterface } from "../../../interfaces/Global.interface";
// FLATBUFFER ENUMS
import { OrgType } from "../../../flatbuffers/generated/archive/org-type";
import { formatUuidT } from "../../../flatbuffers/display";

function SelectOrganizationsLight({
  value,
  onChangeIdOrganization,
  disabledInput,
  filterType,
  withBanks,
  excludeIds,
}: SelectOrganizationInterface) {
  const { organizationsLight: organizations, isLoadingGetAllOrganizationsLight } =
    useGetAllOrganizationsLight(withBanks);

  // Filter by type when requested, including MASTER organizations.
  // If the API doesn't return type yet (backend not deployed), the filter
  // produces an empty list — fall back to showing all orgs so the dropdown isn't empty.
  const filterTypeToEnum: Record<string, OrgType> = {
    MASTER: OrgType.MASTER,
    ORG: OrgType.ORG,
    SUBORG: OrgType.SUBORG,
  };
  const byType = filterType
    ? organizations.filter(
        (org: OganizationLightInterface) => org.type === (filterTypeToEnum[filterType] ?? org.type),
      )
    : organizations;
  const filtered = byType.length > 0 ? byType : organizations;

  // Applied AFTER the type filter and the show-all fallback so excluded orgs can
  // never leak back in — the wizard passes the edited org + its subtree here to
  // prevent picking a parent that would create a cycle.
  const excludeSet = new Set(excludeIds ?? []);
  const options = filtered
    .map((item: OganizationLightInterface) => ({
      value: formatUuidT(item.id),
      label: String(item.name ?? ""),
    }))
    .filter((opt) => !excludeSet.has(opt.value));

  // Check if the current value exists in the filtered options
  const valueExistsInOptions = value && options.some((opt) => opt.value === value);
  const displayValue = valueExistsInOptions ? value : undefined;

  return (
    <Select
      showSearch
      optionFilterProp="label"
      size="small"
      loading={isLoadingGetAllOrganizationsLight}
      value={displayValue}
      onChange={(item: string, _option: any) => {
        onChangeIdOrganization(item, _option);
      }}
      options={options}
      className="generalStyles__width100"
      disabled={disabledInput}
      placeholder="Select organization"
    />
  );
}

export default SelectOrganizationsLight;
